/**
 * Compact labeled select for an existing filter group.
 * Options and the selected value stay with the caller.
 */
export function FilterSelect({ label, ariaLabel, value, onChange, options }) {
  return (
    <label className="inline-flex h-9 items-center gap-2 rounded-md border border-[#D1D5DB] bg-white pl-3 pr-2">
      <span className="shrink-0 text-xs font-semibold text-[#5A5A5A]">{label}</span>
      <select
        aria-label={ariaLabel}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="h-8 max-w-[12rem] cursor-pointer truncate border-0 bg-transparent pr-1 text-sm font-semibold text-[#1F2933] focus:outline-none focus:ring-2 focus:ring-[#00A6D6]/30"
      >
        {options.map((option) => {
          const optionValue = option.value == null ? '' : option.value;
          return (
            <option key={optionValue === '' ? `${ariaLabel}-all` : optionValue} value={optionValue}>
              {option.label}
              {typeof option.count === 'number' ? ` (${option.count})` : ''}
            </option>
          );
        })}
      </select>
    </label>
  );
}
